import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "./ui/Button";

const FiltersCard = (props) => {
    const {
        organizationName,
        relatedOrganizationNames,
        userSelectedOrganizationReports,
        reportId,
        enableresetFilter,
        actionsButtonPosition,
        handleResetFilters,
        isApplyDisabled,
        applyFilter,
        handleApplyFilters,
    } = props;
    const [isOpen, setIsOpen] = useState(true);
    const [filterText, setFilterText] = useState("Hide");

    const toggleDiv = () => {
        const newIsOpen = !isOpen;
        setIsOpen(newIsOpen);

        // Delay the label change by 300ms (adjust as needed)
        setTimeout(() => {
            setFilterText(newIsOpen ? "Hide" : "Show");
        }, 100);
    };

    const buttonsPosition = actionsButtonPosition
        ? "col-lg-12 col-md-4 col-sm-12 d-flex justify-content-end flex-nowrap"
        : "col-lg-3 col-md-6 col-sm-4 col-6 col-print dasboard-actions";

    return (
        <div className="section-card container-heading data-view-card">
            <div className="row" style={{ position: "relative", rowGap: 16 }}>
                <div className="d-flex flex-direction">
                    <div className="filter-header">
                        {/* Organization Info */}
                        <div className="organization-info">
                            <label
                                className="pb-0 header"
                                htmlFor="organization-name"
                            >
                                Organization
                            </label>
                            <p className="sub-text" id="organization-name">
                                {organizationName.length < 30 ? (
                                    organizationName
                                ) : (
                                    <div className="parameter-text d-block">
                                        {organizationName}
                                    </div>
                                )}
                            </p>
                        </div>

                        {/* Related Organizations Info */}
                        <div className="related-orgs-info">
                            <label
                                className="pb-0 header"
                                htmlFor="related-orgs"
                            >
                                Related orgs
                            </label>
                            <p className="sub-text" id="related-orgs">
                                {userSelectedOrganizationReports?.[reportId]
                                    ?.related?.length ? (
                                    <div className="parameter-text d-block">
                                        {relatedOrganizationNames}
                                    </div>
                                ) : (
                                    <span className="d-block">None</span>
                                )}
                            </p>
                        </div>

                        <div
                            className="col-auto ms-auto"
                            style={{ gridColumn: "4 / 5", justifySelf: "end" }}
                        >
                            <div
                                className="d-flex align-items-center filter-toggle-button"
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                        e.preventDefault();
                                        toggleDiv();
                                    }
                                }}
                                onClick={toggleDiv}
                            >
                                <span style={{ paddingRight: 8 }}>
                                    {filterText} filters
                                </span>
                                <i className="fas fa-filter me-2"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && (
                <div
                    className="row"
                    style={{ rowGap: 16, marginTop: 10, position: "relative" }}
                >
                    {props.children}
                    <div className={buttonsPosition}>
                        <div
                            className={
                                actionsButtonPosition
                                    ? "dashboard-actions-new-row"
                                    : "dashboard-filter-actions"
                            }
                        >
                            <Button
                                text="Reset"
                                disabled={!enableresetFilter}
                                outline={true}
                                aria-label="Reset"
                                onClick={() => handleResetFilters()}
                            />
                            <Button
                                text="Apply"
                                disabled={isApplyDisabled || !applyFilter}
                                variant="inverse"
                                aria-label="Apply"
                                onClick={() => handleApplyFilters()}
                            />
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

FiltersCard.propTypes = {
    organizationName: PropTypes.string,
    relatedOrganizationNames: PropTypes.string,
    userSelectedOrganizationReports: PropTypes.object,
    reportId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    children: PropTypes.node,
    enableresetFilter: PropTypes.bool,
    actionsButtonPosition: PropTypes.bool,
    handleResetFilters: PropTypes.func.isRequired,
    isApplyDisabled: PropTypes.bool,
    applyFilter: PropTypes.bool,
    handleApplyFilters: PropTypes.func.isRequired,
};

export default FiltersCard;
